import React from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Box, Typography } from '@mui/material';

import { IdealCaseloadAlerts, IdealCaseloadInput, useUpdateIdealCaseload, FullscreenFormContainer, FullscreenFormFooter } from '@uplift/ui-v2';
import { useCurrentuser } from '@uplift/contexts';
import { asyncWait } from '@uplift/utils';
import { useL10n } from '@uplift/hooks';


const caseloadSchema = Yup.object().shape({
  caseload: Yup.number().transform(val => parseInt(val || '0')).min(1, ' ').max(99, ' ').required(' '),
});


export const FUEIdealCaseloadForm: React.FC<{
  onSuccess: () => void;
  idealCaseload?: number;
  style?: React.CSSProperties;
  disabled?: boolean;
}> = (props) => {
  const me = useCurrentuser();
  const l10n = useL10n();
  const updateIdealCaseload = useUpdateIdealCaseload();

  const handleSubmit = React.useCallback(async (values: { caseload: string }) => {
    await Promise.all([
      updateIdealCaseload({
        userId: me.id,
        caseload: parseInt(values.caseload),
      }),
      asyncWait(500),
    ]);
    props.onSuccess();
  }, [ me.id, updateIdealCaseload ]);

  return (
    <Formik
      initialValues={{
        caseload: props.idealCaseload ? props.idealCaseload.toString() : ''
      }}
      validationSchema={caseloadSchema}
      onSubmit={handleSubmit}
    >
      {formik => (
        <FullscreenFormContainer>
          <Box style={props.style}>
            <Box>
              <Typography variant="overline" color="secondary">{l10n.schedule.configuration.idealCaseload.setYourRecurringAvailability}</Typography>
            </Box>
            <Box mt={2}>
              <Typography variant="h4">{l10n.schedule.configuration.idealCaseload.whatIsYourIdealWeeklyCaseload}</Typography>
            </Box>
            <Box mt={1}>
              <Typography variant="body1" color="textSecondary">{l10n.schedule.configuration.idealCaseload.weCanSuggestHowManyHours}</Typography>
            </Box>
            <Box mt={2} width="54px" position="relative">
              <IdealCaseloadInput name="caseload" color="secondary" />
            </Box>
            <Box mt={1}>
              <IdealCaseloadAlerts caseload={formik.values.caseload} />
            </Box>
            <Box mt={8}>
              <FullscreenFormFooter
                loading={formik.isSubmitting || props.disabled}
                nextDisabled={!formik.isValid || props.disabled || !formik.values.caseload}
                onNext={formik.handleSubmit}
              />
            </Box>
          </Box>
        </FullscreenFormContainer>
      )}
    </Formik>
  );
};
